module.exports = __webpack_public_path__ + "img/img-pdf-mockup-1.5be451b0.png";